import i18n from '@/app-shared/i18n';
const STEP_OPTS = {
  VIDEO: 0,
  AUDIO_INPUT: 1,
  AUDIO_OUTPUT: 2,
  RESULT: 3
};
const DESC_OPTS = {
  SWITCHING: `${i18n.t('host.k_653001')}`,
  FORBIDDEN: `${i18n.t('host.k_653002')}`,
  PREVIEW_ERROR: `${i18n.t('host.k_653003')}`,
  SWITCHING_ERROR: `${i18n.t('host.k_653004')}`
};
export { STEP_OPTS, DESC_OPTS };
